<template>
    <el-dialog
        v-model="isOpen"
        :title="title"
        width="30%"
        center
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
        <span>{{ text }}</span>
        <template #footer>
            <span class="dialog-footer">
                <el-button type="danger" @click="handleSubmit(true)">
                    Delete
                </el-button>

                <el-button @click="handleSubmit(false)"> Cancel </el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';

const AppConfirmDeleteDialog = defineComponent({
    props: {
        id: {
            type: Number,
            default: null,
        },
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
    },
    emits: ['submit-delete'],
    setup(props, context) {
        const isOpen = computed(() => {
            return props.id != null;
        });
        const handleSubmit = (agree: boolean) => {
            context.emit('submit-delete', agree);
        };
        const handleClose = () => {
            context.emit('submit-delete', false);
        };

        return {
            isOpen,
            handleSubmit,
            handleClose,
        };
    },
});
export default AppConfirmDeleteDialog;
</script>
